export default __webpack_public_path__ + "static/media/natural.e3be8116.png";